import { Values } from '../../../utils/types';

export const DATA_TYPE = {
  arrayNumber: 'array<number>',
  arrayObject: 'array<object>',
  arrayString: 'array<string>',
  boolean: 'boolean',
  date: 'date',
  dictionary: 'dictionary',
  guid: 'GUID',
  number: 'number',
  object: 'object',
  schedule: 'schedule',
  string: 'string',
} as const;

export type DataType = Values<typeof DATA_TYPE>;
